import React from 'react';
import PropTypes from 'prop-types';
import SectionWrapper from 'ferries/Home/components/SectionWrapper';
import LazyImage from 'helpers/LazyImage';
import {replaceAssetsImgUrl} from 'cms/helpers/common';

const LatestUpdates = ({latestUpdates}) => {
  const {title, subtitle, image, summary, link, readMore} = latestUpdates;

  return (
    <SectionWrapper title={title} subtitle={subtitle}>
      <div className="grid border rounded py-3 mx-0 mx-md-6 bg-snow">
        <div className="grid-item-sm">
          <LazyImage
            imgClass="object-fit-cover rounded"
            src={replaceAssetsImgUrl(image)}
            width="100%"
            height="150px"
            title={title}
            alt={title}
          />
        </div>
        <div className="grid-item-sm">
          {summary}<br/><a href={link} target="_blank" rel="noreferrer">{readMore}</a>
        </div>
      </div>
    </SectionWrapper>
  );
};

LatestUpdates.propTypes = {
  latestUpdates: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    summary: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    readMore: PropTypes.string.isRequired
  })
};

export default LatestUpdates;
